import SentryService from '@/services/sentry/Sentry.service';
import { useEffect, useState } from 'react';
import { Image } from 'react-native';

export const useImageRatio = (imageUri: string) => {
  const [ratio, setRatio] = useState(1);

  useEffect(() => {
    if (!imageUri) {
      setRatio(1);
      return;
    }

    Image.getSize(
      imageUri,
      (w, h) => {
        setRatio(w / h);
      },
      (error) => {
        SentryService.captureError(
          `Failed to get image size for URI: ${imageUri}:`,
          error,
        );
      },
    );
  }, [imageUri]);

  return ratio;
};
